import add_node from "./assets/add_node.svg"
import add_user from "./assets/add_user.svg"
import aggregation_avg from "./assets/aggregation_avg.svg"
import aggregation_max from "./assets/aggregation_max.svg"
import aggregation_med from "./assets/aggregation_med.svg"
import aggregation_min from "./assets/aggregation_min.svg"
import aggregation_sum from "./assets/aggregation_sum.svg"
import aggregation_sum_abs from "./assets/aggregation_sum_abs.svg"
import ai from "./assets/ai.svg"
import alarm from "./assets/alarm.svg"
import alarm_bell from "./assets/alarm_bell.svg"
import alarm_off from "./assets/alarm_off.svg"
import alarmCritical from "./assets/alarm_c.svg"
import alarmCriticalWarning from "./assets/alarm_cw.svg"
import alarmFilled from "./assets/alarmFilled.svg"
import alarmNew from "./assets/alarm_new.svg"
import alarms_new from "./assets/alarms_new.svg"
import alarmWarning from "./assets/alarm_w.svg"
import alertInvestigation from "./assets/insights/alert_investigation_colored.svg"
import anomaliesBrain from "./assets/anomalies_brain.svg"
import anomaliesLens from "./assets/anomalies_lens.svg"
import anomalyAnalysis from "./assets/insights/anomaly_analysis_colored.svg"
import anomalyBadge from "./assets/anomaly_badge.svg"
import antenna from "./assets/antenna.svg"
import applications_hollow from "./assets/applications_hollow.svg"
import applicationsSolid from "./assets/applications_solid.svg"
import around_clock from "./assets/around_clock.svg"
import arrow_down from "./assets/arrow_down.svg"
import arrow_left from "./assets/arrow_left.svg"
import arrow_s_down from "./assets/arrow-s_down.svg"
import arrow_s_left from "./assets/arrow-s_left.svg"
import arrow_w_line_left from "./assets/arrow_w_line_left.svg"
import arrow_w_line_right from "./assets/arrow_w_line_right.svg"
import arrows_vertical from "./assets/arrows_vertical.svg"
import auth from "./assets/auth.svg"
import automatedTroubleshooting from "./assets/insights/automated_troubleshooting_colored.svg"
import bookmark from "./assets/bookmark.svg"
import bullet_one from "./assets/bullet_one.svg"
import bullet_three from "./assets/bullet_three.svg"
import bullet_two from "./assets/bullet_two.svg"
import calendarFull from "./assets/calendar_full.svg"
import calendarFullPress from "./assets/calendar_full_press.svg"
import capacityPlanning from "./assets/insights/capacity_planning_colored.svg"
import chart_added from "./assets/chart_added.svg"
import chart_bars from "./assets/chart_bars.svg"
import chart_circle from "./assets/chart_circle.svg"
import chart_gauge from "./assets/chart_gauge.svg"
import chart_pie from "./assets/chart_pie.svg"
import charts from "./assets/charts.svg"
import charts_view from "./assets/charts_view.svg"
import check from "./assets/check.svg"
import checkmark from "./assets/checkmark.svg"
import checkmark_partial_s from "./assets/checkmark_partial_s.svg"
import checkmark_s from "./assets/checkmark_s.svg"
import chevron_double from "./assets/chevron_double.svg"
import chevron_down from "./assets/chevron_down.svg"
import chevron_down_thin from "./assets/chevron_down_thin.svg"
import chevron_expand from "./assets/chevron_expand.svg"
import chevron_left from "./assets/chevron_left.svg"
import chevron_left_small from "./assets/chevron_left_small.svg"
import chevron_left_start from "./assets/chevron_left_start.svg"
import chevron_right from "./assets/chevron_right.svg"
import chevron_right_end from "./assets/chevron_right_end.svg"
import chevron_right_s from "./assets/chevron_right_s.svg"
import chevron_right_small from "./assets/chevron_right_small.svg"
import chevron_up_thin from "./assets/chevron_up_thin.svg"
import classError from "./assets/class_error.svg"
import classLatency from "./assets/class_latency.svg"
import classUtilization from "./assets/class_utilization.svg"
import classWorkload from "./assets/class_workload.svg"
import clock_hollow from "./assets/clock_hollow.svg"
import clock5Min from "./assets/clock_5_min.svg"
import clock5MinPress from "./assets/clock_5_min_press.svg"
import close_circle from "./assets/close_circle.svg"
import cluster from "./assets/cluster.svg"
import cluster_spaces from "./assets/cluster_spaces.svg"
import code from "./assets/code.svg"
import collapse from "./assets/collapse.svg"
import collect from "./assets/collect.svg"
import community from "./assets/community.svg"
import connection_to_cloud from "./assets/connection_to_cloud.svg"
import connectivityStatusLive from "./assets/connectivity_status_live.svg"
import connectivityStatusOffline from "./assets/connectivity_status_offline.svg"
import connectivityStatusStale from "./assets/connectivity_status_stale.svg"
import container from "./assets/container.svg"
import controller_kind from "./assets/controller_kind.svg"
import controller_name from "./assets/controller_name.svg"
import conversationSubject from "./assets/conversation_subject.svg"
import copy from "./assets/copy.svg"
import correlation from "./assets/correlation.svg"
import correlation_inv from "./assets/correlation_inv.svg"
import cpu from "./assets/cpu.svg"
import cross_s from "./assets/cross_s.svg"
import dashboard from "./assets/dashboard.svg"
import dashboard_add from "./assets/dashboard_add.svg"
import dashboards from "./assets/dashboards.svg"
import data_retention from "./assets/data_retention.svg"
import database from "./assets/database.svg"
import discoveredConfig from "./assets/discovered_config.svg"
import disk from "./assets/disk.svg"
import documentation from "./assets/documentation.svg"
import dot from "./assets/dot.svg"
import dots_2x3 from "./assets/dots_2x3.svg"
import download from "./assets/download.svg"
import dragHorizontal from "./assets/drag_horizontal.svg"
import dynamicConfig from "./assets/dynamic_config.svg"
import earlyAccess from "./assets/early-access.svg"
import edit from "./assets/edit.svg"
import error from "./assets/error.svg"
import exclamation from "./assets/exclamation.svg"
import expand from "./assets/expand.svg"
import favorites from "./assets/favorites.svg"
import feed from "./assets/feed.svg"
import filter from "./assets/filter.svg"
import filterList from "./assets/filterList.svg"
import firewallSolid from "./assets/firewall_solid.svg"
import forcePlay from "./assets/force_play.svg"
import forcePlayOutline from "./assets/force_play_outline.svg"
import fullScreen from "./assets/full_screen.svg"
import functions from "./assets/functions.svg"
import gear from "./assets/gear.svg"
import giftbox from "./assets/gift_box.svg"
import github from "./assets/github.svg"
import google from "./assets/google.svg"
import goToNode from "./assets/go_to_node.svg"
import grid from "./assets/grid.svg"
import group_by from "./assets/group_by.svg"
import groupCreate from "./assets/group_create.svg"
import h1 from "./assets/h1.svg"
import h2 from "./assets/h2.svg"
import hamburger from "./assets/hamburger.svg"
import heart from "./assets/heart.svg"
import heart_broken from "./assets/heart_broken.svg"
import heart_hollow from "./assets/heart_hollow.svg"
import help from "./assets/help.svg"
import hide from "./assets/hide.svg"
import highlightArea from "./assets/highlight_area.svg"
import holder from "./assets/holder.svg"
import importExport from "./assets/importExport.svg"
import incident_manager from "./assets/incident_manager.svg"
import information from "./assets/information.svg"
import informationPress from "./assets/information_press.svg"
import insights from "./assets/insights.svg"
import integrationAWS from "./assets/integrations/aws.svg"
import integrationAWSSNS from "./assets/integrations/aws_sns.svg"
import integrationAWSSNSColored from "./assets/integrations/aws_sns_colored.svg"
import integrationDiscord from "./assets/integrations/discord.svg"
import integrationDiscordColored from "./assets/integrations/discord_colored.svg"
import integrationEmail from "./assets/integrations/email.svg"
import integrationEmailColored from "./assets/integrations/email_colored.svg"
import integrationIlert from "./assets/integrations/ilert.svg"
import integrationIlertColored from "./assets/integrations/ilert_colored.svg"
import integrationJiraColored from "./assets/integrations/jira_colored.svg"
import integrationMattermost from "./assets/integrations/mattermost.svg"
import integrationMattermostColored from "./assets/integrations/mattermost_colored.svg"
import integrationMobileAppColored from "./assets/integrations/mobile_app_colored.svg"
import integrationOpsgenie from "./assets/integrations/opsgenie.svg"
import integrationOpsgenieColored from "./assets/integrations/opsgenie_colored.svg"
import integrationPagerduty from "./assets/integrations/pagerduty.svg"
import integrationPagerdutyColored from "./assets/integrations/pagerduty_colored.svg"
import integrationRocketChat from "./assets/integrations/rocketChat.svg"
import integrationRocketChatColored from "./assets/integrations/rocketChat_colored.svg"
import integrationServiceNow from "./assets/integrations/serviceNow.svg"
import integrationServiceNowColored from "./assets/integrations/serviceNow_colored.svg"
import integrations from "./assets/integrations.svg"
import integrationSlack from "./assets/integrations/slack.svg"
import integrationSlackColored from "./assets/integrations/slack_colored.svg"
import integrationSMSEagle from "./assets/integrations/smseagle.svg"
import integrationSMSEagleColored from "./assets/integrations/smseagle_colored.svg"
import integrationSplunk from "./assets/integrations/splunk-black.svg"
import integrationTeams from "./assets/integrations/teams.svg"
import integrationTeamsColored from "./assets/integrations/teams_colored.svg"
import integrationTelegram from "./assets/integrations/telegram.svg"
import integrationTelegramColored from "./assets/integrations/telegram_colored.svg"
import integrationVictorOps from "./assets/integrations/victorOps.svg"
import integrationVictorOpsColored from "./assets/integrations/victorOps_colored.svg"
import integrationWebhook from "./assets/integrations/webhook.svg"
import integrationWebhookColored from "./assets/integrations/webhook_colored.svg"
import internalConfig from "./assets/internal_config.svg"
import investigation from "./assets/insights/investigation_colored.svg"
import ipNetworking from "./assets/ipNetworking.svg"
import ipNetworkingPress from "./assets/ipNetworkingPress.svg"
import last_week from "./assets/last_week.svg"
import line_chart from "./assets/line_chart.svg"
import list from "./assets/list.svg"
import live from "./assets/live.svg"
import loading from "./assets/loading.svg"
import logo_s from "./assets/logo_s.svg"
import logs from "./assets/logs.svg"
import long_arrow_up from "./assets/long_arrow_up.svg"
import magnify from "./assets/magnify.svg"
import metrics from "./assets/metrics.svg"
import metrics_explorer from "./assets/metrics_explorer.svg"
import minimize_s from "./assets/minimize_s.svg"
import mobilePushNotifications from "./assets/mobile_push_notifications.svg"
import mobilePushNotificationsHollow from "./assets/mobile_push_notifications_hollow.svg"
import monitoring from "./assets/monitoring.svg"
import more from "./assets/more.svg"
import nav_arrow_goto from "./assets/nav_arrow_goto.svg"
import nav_dots from "./assets/nav_dots.svg"
import navLeft from "./assets/nav_left.svg"
import navRight from "./assets/nav_right.svg"
import netdata from "./assets/netdata.svg"
import netdataAssistant from "./assets/netdataAssistant.svg"
import netdataPress from "./assets/netdata-press.svg"
import networkingStack from "./assets/networking_stack.svg"
import node from "./assets/node.svg"
import node_child from "./assets/node_child.svg"
import node_default_l from "./assets/node_default_l.svg"
import node_hollow from "./assets/node_hollow.svg"
import node_import_export from "./assets/node_import_export.svg"
import node_notification_l from "./assets/node_notification_l.svg"
import node_parent from "./assets/node_parent.svg"
import node_selected_l from "./assets/node_selected_l.svg"
import nodes from "./assets/nodes.svg"
import nodes_hollow from "./assets/nodes_hollow.svg"
import nodes_update from "./assets/nodes_update.svg"
import none_selected from "./assets/none_selected.svg"
import notification from "./assets/notification.svg"
import notification_shortcut_disabled from "./assets/notification_shortcut_disabled.svg"
import notification_shortcut_enabled from "./assets/notification_shortcut_enabled.svg"
import notificationTrigger from "./assets/notification_trigger.svg"
import okta from "./assets/okta.svg"
import openid from "./assets/openid.svg"
import os from "./assets/os/os.svg"
import os3ComHuawei from "./assets/os/huawei.svg"
import osAlcatelLucent from "./assets/os/alcatellucent.svg"
import osAllied from "./assets/os/alliedtelesis.svg"
import osAlpineLinux from "./assets/os/alpine_linux.svg"
import osAmazonLinux from "./assets/os/amazon_linux.svg"
import osAPC from "./assets/os/apc.svg"
import osArchLinux from "./assets/os/arch_linux.svg"
import osArista from "./assets/os/arista.svg"
import osAruba from "./assets/os/aruba.svg"
import osAvaya from "./assets/os/avaya.svg"
import osAvocent from "./assets/os/avocent.svg"
import osAVTECH from "./assets/os/avtech.svg"
import osBarracuda from "./assets/os/barracuda.svg"
import osBrocade from "./assets/os/brocade.svg"
import osBrother from "./assets/os/brother.svg"
import osCelarOS from "./assets/os/celarOS.svg"
import osCentos from "./assets/os/centos.svg"
import osCentosColored from "./assets/os/centos_colored.svg"
import osCiena from "./assets/os/ciena.svg"
import osCisco from "./assets/os/cisco.svg"
import osCitrix from "./assets/os/citrix.svg"
import osCoreOS from "./assets/os/coreOS.svg"
import osCyberpower from "./assets/os/cyberpower.svg"
import osDebian from "./assets/os/debian.svg"
import osDebianColored from "./assets/os/debian_colored.svg"
import osDell from "./assets/os/dell.svg"
import osDLink from "./assets/os/dlink.svg"
import osEaton from "./assets/os/eaton.svg"
import osEricsson from "./assets/os/ericsson.svg"
import osExtreme from "./assets/os/extreme.svg"
import osF5 from "./assets/os/f5.svg"
import osFedora from "./assets/os/fedora.svg"
import osFireeye from "./assets/os/trellix.svg"
import osFortinet from "./assets/os/fortinet.svg"
import osFreeBSD from "./assets/os/freebsd.svg"
import osGentoo from "./assets/os/gentoo.svg"
import osHP from "./assets/os/hp.svg"
import osHPE from "./assets/os/hpe.svg"
import osHuawei from "./assets/os/huawei.svg"
import osIBM from "./assets/os/ibmos.svg"
import osInfoblox from "./assets/os/infoblox.svg"
import osKyocera from "./assets/os/kyocera.svg"
import osLinux from "./assets/os/linux.svg"
import osLinuxColored from "./assets/os/linux_colored.svg"
import osLinuxManjaro from "./assets/os/linux_manjaro.svg"
import osMacOSX from "./assets/os/macOSX.svg"
import osMikroTik from "./assets/os/mikrotik.svg"
import osNEC from "./assets/os/nec.svg"
import osNetApp from "./assets/os/netapp.svg"
import osNETGEAR from "./assets/os/netgear.svg"
import osNokia from "./assets/os/nokia.svg"
import osOpengear from "./assets/os/opengear.svg"
import osOracle from "./assets/os/oracle.svg"
import osOracleColored from "./assets/os/oracle_colored.svg"
import osPaloAlto from "./assets/os/panos.svg"
import osPeplink from "./assets/os/peplink.svg"
import osPfSense from "./assets/os/pfsense.svg"
import osPress from "./assets/os/os_press.svg"
import osProxmox from "./assets/os/proxmox.svg"
import osRaritan from "./assets/os/raritan.svg"
import osRaspbian from "./assets/os/raspbian.svg"
import osRedHat from "./assets/os/red_hat.svg"
import osRuckus from "./assets/os/ruckus.svg"
import osSuseLinux from "./assets/os/suse_linux.svg"
import osSynology from "./assets/os/synology.svg"
import osTPLink from "./assets/os/tplink.svg"
import osTrippLite from "./assets/os/tripplite.svg"
import osUbiquiti from "./assets/os/ubiquiti.svg"
import osUbuntu from "./assets/os/ubuntu.svg"
import osUbuntuColored from "./assets/os/ubuntu_colored.svg"
import osVertiv from "./assets/os/vertiv.svg"
import osVMware from "./assets/os/vmware.svg"
import osWatchGuard from "./assets/os/watchguard.svg"
import osZebra from "./assets/os/zebra.svg"
import osZyxel from "./assets/os/zyxel.svg"
import padlock from "./assets/padlock.svg"
import panTool from "./assets/pan_tool.svg"
import pauseOutline from "./assets/pause_outline.svg"
import pauseSolid from "./assets/pause_solid.svg"
import pencilOutline from "./assets/pencil_outline.svg"
import pencilSolid from "./assets/pencil_solid.svg"
import performanceOptimization from "./assets/insights/performance_optimization_colored.svg"
import pie_chart_skeleton from "./assets/pie_chart_skeleton.svg"
import pin_element from "./assets/pin_element.svg"
import playOutline from "./assets/play_outline.svg"
import playSolid from "./assets/play_solid.svg"
import plus from "./assets/plus.svg"
import plus_mini_s from "./assets/plus_mini_s.svg"
import pod from "./assets/pod.svg"
import pricing from "./assets/pricing.svg"
import print from "./assets/print.svg"
import privacy from "./assets/privacy.svg"
import pushNotifications from "./assets/integrations/push_notifications.svg"
import qrCode from "./assets/qr_code.svg"
import qualityOfServiceSolid from "./assets/qualityOfService_solid.svg"
import question from "./assets/question.svg"
import questionFilled from "./assets/questionFilled.svg"
import ram from "./assets/ram.svg"
import rearrange from "./assets/rearrange.svg"
import reduceSize from "./assets/reduce_size.svg"
import refresh from "./assets/refresh.svg"
import reload from "./assets/reload.svg"
import removeNode from "./assets/remove_node.svg"
import resize_handler from "./assets/resize_handler.svg"
import rocket from "./assets/rocket.svg"
import rotate_ccw from "./assets/rotate_ccw.svg"
import rotate_cw from "./assets/rotate_cw.svg"
import room from "./assets/room.svg"
import room_home from "./assets/room_home.svg"
import room_new from "./assets/room_new.svg"
import room_overview from "./assets/room_overview.svg"
import sad from "./assets/sad.svg"
import save from "./assets/save.svg"
import save2 from "./assets/save2.svg"
import scheduled from "./assets/scheduled.svg"
import search from "./assets/search.svg"
import search_s from "./assets/search_s.svg"
import searchPress from "./assets/search_press.svg"
import serviceAlarm from "./assets/alarm.svg"
import serviceApache from "./assets/services/apache.svg"
import serviceApacheTomcat from "./assets/services/apache_tomcat.svg"
import serviceAsterisk from "./assets/services/asterisk.svg"
import serviceBeanstalk from "./assets/services/beanstalk.svg"
import serviceBind from "./assets/services/bind.svg"
import serviceContainer from "./assets/services/containerTech.svg"
import serviceCoreDns from "./assets/services/coreDNS.svg"
import serviceCouchDB from "./assets/services/couchDB.svg"
import serviceDatabase from "./assets/services/database.svg"
import serviceDNS from "./assets/services/dns.svg"
import serviceDNSmasq from "./assets/services/dnsmasq.svg"
import serviceDockerHub from "./assets/services/docker_hub.svg"
import serviceDockerHubPress from "./assets/services/docker_hub_press.svg"
import serviceDotNet from "./assets/services/dotnet.svg"
import serviceEBPF from "./assets/services/eBPF.svg"
import serviceElasticSearch from "./assets/services/elasticSearch.svg"
import serviceExample from "./assets/services/example.svg"
import serviceFreeNAS from "./assets/services/freeNAS.svg"
import serviceHAProxy from "./assets/services/haProxy.svg"
import serviceHTTPCheck from "./assets/services/httpCheck.svg"
import serviceIceCast from "./assets/services/iceCast.svg"
import serviceInfluxDB from "./assets/services/influxDB.svg"
import serviceIPFS from "./assets/services/ipfs.svg"
import serviceIPVS from "./assets/services/ipvs.svg"
import serviceKubernetes from "./assets/services/kubernetes.svg"
import serviceLighthttpd from "./assets/services/lighthttpd.svg"
import serviceLighthttpd2 from "./assets/services/lighthttpd2.svg"
import serviceLiteSpeed from "./assets/services/liteSpeed.svg"
import serviceLxc from "./assets/services/lxc.svg"
import serviceMariaDB from "./assets/services/mariaDB.svg"
import serviceMemCached from "./assets/services/memCached.svg"
import serviceMongoDB from "./assets/services/mongoDB.svg"
import serviceMySQL from "./assets/services/mySQL.svg"
import serviceMySQLPress from "./assets/services/mySQL_press.svg"
import serviceNginx from "./assets/services/nginx.svg"
import serviceNginxLocal from "./assets/services/nginx_local.svg"
import serviceNginxPlus from "./assets/services/nginx_plus.svg"
import serviceNtpd from "./assets/services/ntpd.svg"
import serviceNtpdPress from "./assets/services/ntpd_press.svg"
import serviceNvidia from "./assets/services/nvidia.svg"
import serviceOpenStack from "./assets/services/openStack.svg"
import serviceOpenTelemetry from "./assets/services/openTelemetry.svg"
import serviceOpenWrt from "./assets/services/openWrt.svg"
import servicePan from "./assets/services/pan.svg"
import servicePandas from "./assets/services/pandas.svg"
import servicePercona from "./assets/services/percona.svg"
import servicePfSense from "./assets/services/pfSense.svg"
import servicePhpFpm from "./assets/services/php_fpm.svg"
import servicePostgreSQL from "./assets/services/postgreSQL.svg"
import servicePrometheus from "./assets/services/prometheus.svg"
import serviceProxySQL from "./assets/services/proxySQL.svg"
import serviceRabbitMQ from "./assets/services/rabbitMQ.svg"
import serviceRandom from "./assets/services/random.svg"
import serviceRedis from "./assets/services/redis.svg"
import serviceRethinkDB from "./assets/services/rethinkDB.svg"
import serviceRetroShare from "./assets/services/retroShare.svg"
import services from "./assets/services/services.svg"
import serviceSelectedArea from "./assets/services/selected_area.svg"
import serviceSendgrid from "./assets/services/sendgrid.svg"
import serviceSolr from "./assets/services/solr.svg"
import serviceSquid from "./assets/services/squid.svg"
import servicesSmartdlog from "./assets/services/smartdlog.svg"
import serviceSummaryStatistic from "./assets/services/summary_statistic.svg"
import serviceSystemd from "./assets/services/systemd.svg"
import serviceTraefik from "./assets/services/traefik.svg"
import serviceVarnish from "./assets/services/varnish.svg"
import serviceWebLog from "./assets/services/webLog.svg"
import serviceWebLogNginx from "./assets/services/webLog_nginx.svg"
import serviceX509Check from "./assets/services/x509_check.svg"
import serviceXen from "./assets/services/xen.svg"
import settings from "./assets/settings.svg"
import settings_h from "./assets/settings_h.svg"
import share from "./assets/share.svg"
import sign_in from "./assets/sign_in.svg"
import socialChat from "./assets/social_chat.svg"
import sort_ascending from "./assets/sort_ascending.svg"
import sort_descending from "./assets/sort_descending.svg"
import sort_indicator from "./assets/sort_indicator.svg"
import sorting_asc from "./assets/sorting_asc.svg"
import sorting_desc from "./assets/sorting_desc.svg"
import sorting_vertical from "./assets/sorting_vertical.svg"
import space from "./assets/space.svg"
import space_new from "./assets/space_new.svg"
import spaces_v2 from "./assets/spaces_v2.svg"
import stockConfig from "./assets/stock_config.svg"
import switch_off from "./assets/switch_off.svg"
import system_overview from "./assets/system_overview.svg"
import systemOverviewPress from "./assets/system_overview_press.svg"
import text_add from "./assets/text_add.svg"
import thumb_down from "./assets/thumb_down.svg"
import thumb_up from "./assets/thumb_up.svg"
import thunder from "./assets/thunder.svg"
import tiny_buttons from "./assets/tiny_buttons.svg"
import tools from "./assets/tools.svg"
import top from "./assets/top.svg"
import training from "./assets/training.svg"
import trashcan from "./assets/trashcan.svg"
import triangle from "./assets/triangle.svg"
import triangle_down from "./assets/triangle_down.svg"
import universe from "./assets/universe.svg"
import unknownError from "./assets/unknownError.svg"
import unreachable from "./assets/unreachable.svg"
import unreachableNode from "./assets/unreachableNode.svg"
import update from "./assets/update.svg"
import update_pending from "./assets/update_pending.svg"
import upload from "./assets/upload.svg"
import user from "./assets/user.svg"
import userConfig from "./assets/user_config.svg"
import userPress from "./assets/user_press.svg"
import users from "./assets/users.svg"
import value from "./assets/value.svg"
import view_list from "./assets/view_list.svg"
import viewSingleNode from "./assets/views/single_node_view.svg"
import viewSingleNodePress from "./assets/views/single_node_view_press.svg"
import virtualization from "./assets/virtualization.svg"
import warning from "./assets/warning.svg"
import warning_triangle from "./assets/warning_triangle.svg"
import warning_triangle_hollow from "./assets/warning_triangle_hollow.svg"
import weights_compare from "./assets/weights_compare.svg"
import weights_drill_down from "./assets/weights_drill_down.svg"
import windows from "./assets/os/windows.svg"
import x from "./assets/x.svg"
import zoomIn from "./assets/zoom_in.svg"
import zoomOut from "./assets/zoom_out.svg"
import zoomReset from "./assets/zoom_reset.svg"

import N from "./assets/N.svg"
import I from "./assets/I.svg"
import D from "./assets/D.svg"
import L from "./assets/L.svg"

export const iconsList = {
  add_node,
  add_user,
  aggregation_avg,
  aggregation_max,
  aggregation_med,
  aggregation_min,
  aggregation_sum_abs,
  aggregation_sum,
  ai,
  alarm_bell,
  alarm_off,
  alarm,
  alarmCritical,
  alarmCriticalWarning,
  alarmFilled,
  alarmNew,
  alarms_new,
  alarmWarning,
  alertInvestigation,
  anomaliesBrain,
  anomaliesLens,
  anomalyAnalysis,
  anomalyBadge,
  antenna,
  applications_hollow,
  applicationsSolid,
  around_clock,
  arrow_down,
  arrow_left,
  arrow_s_down,
  arrow_s_left,
  arrow_w_line_left,
  arrow_w_line_right,
  arrows_vertical,
  auth,
  automatedTroubleshooting,
  bookmark,
  bullet_one,
  bullet_three,
  bullet_two,
  calendarFull,
  calendarFullPress,
  capacityPlanning,
  chart_added,
  chart_bars,
  chart_circle,
  chart_gauge,
  chart_pie,
  charts_view,
  charts,
  check,
  checkmark_partial_s,
  checkmark_s,
  checkmark,
  chevron_double,
  chevron_down_thin,
  chevron_down,
  chevron_expand,
  chevron_left_small,
  chevron_left_start,
  chevron_left,
  chevron_right_end,
  chevron_right_s,
  chevron_right_small,
  chevron_right,
  chevron_up_thin,
  classError,
  classLatency,
  classUtilization,
  classWorkload,
  clock_hollow,
  clock5Min,
  clock5MinPress,
  close_circle,
  cluster_spaces,
  cluster,
  code,
  collapse,
  collect,
  community,
  connection_to_cloud,
  connectivityStatusLive,
  connectivityStatusOffline,
  connectivityStatusStale,
  container,
  controller_kind,
  controller_name,
  conversationSubject,
  copy,
  correlation_inv,
  correlation,
  cpu,
  cross_s,
  dashboard_add,
  dashboard,
  dashboards,
  data_retention,
  database,
  discoveredConfig,
  disk,
  documentation,
  dot,
  dots_2x3,
  download,
  dragHorizontal,
  dynamicConfig,
  earlyAccess,
  edit,
  error,
  exclamation,
  expand,
  favorites,
  feed,
  filter,
  filterList,
  firewallSolid,
  forcePlay,
  forcePlayOutline,
  fullScreen,
  functions,
  gear,
  giftbox,
  github,
  google,
  goToNode,
  grid,
  group_by,
  groupCreate,
  h1,
  h2,
  hamburger,
  heart_broken,
  heart_hollow,
  heart,
  help,
  hide,
  highlightArea,
  holder,
  importExport,
  incident_manager,
  information,
  informationPress,
  insights,
  integrationAWS,
  integrationAWSSNS,
  integrationAWSSNSColored,
  integrationDiscord,
  integrationDiscordColored,
  integrationEmail,
  integrationEmailColored,
  integrationIlert,
  integrationIlertColored,
  integrationJiraColored,
  integrationMattermost,
  integrationMattermostColored,
  integrationMobileAppColored,
  integrationOpsgenie,
  integrationOpsgenieColored,
  integrationPagerduty,
  integrationPagerdutyColored,
  integrationRocketChat,
  integrationRocketChatColored,
  integrationServiceNow,
  integrationServiceNowColored,
  integrations,
  integrationSlack,
  integrationSlackColored,
  integrationSMSEagle,
  integrationSMSEagleColored,
  integrationSplunk,
  integrationTeams,
  integrationTeamsColored,
  integrationTelegram,
  integrationTelegramColored,
  integrationVictorOps,
  integrationVictorOpsColored,
  integrationWebhook,
  integrationWebhookColored,
  internalConfig,
  investigation,
  ipNetworking,
  ipNetworkingPress,
  last_week,
  line_chart,
  list,
  live,
  loading,
  logo_s,
  logs,
  long_arrow_up,
  magnify,
  metrics_explorer,
  metrics,
  minimize_s,
  mobilePushNotifications,
  mobilePushNotificationsHollow,
  monitoring,
  more,
  nav_arrow_goto,
  nav_dots,
  navLeft,
  navRight,
  netdata,
  netdataAssistant,
  netdataPress,
  networkingStack,
  node_child,
  node_default_l,
  node_hollow,
  node_import_export,
  node_notification_l,
  node_parent,
  node_selected_l,
  node,
  nodes_hollow,
  nodes_update,
  nodes,
  none_selected,
  notification_shortcut_disabled,
  notification_shortcut_enabled,
  notification,
  notificationTrigger,
  okta,
  openid,
  os,
  os3ComHuawei,
  osAlcatelLucent,
  osAllied,
  osAlpineLinux,
  osAmazonLinux,
  osAPC,
  osArchLinux,
  osArista,
  osAruba,
  osAvaya,
  osAvocent,
  osAVTECH,
  osBarracuda,
  osBrocade,
  osBrother,
  osCelarOS,
  osCentos,
  osCentosColored,
  osCiena,
  osCisco,
  osCitrix,
  osCoreOS,
  osCyberpower,
  osDebian,
  osDebianColored,
  osDell,
  osDLink,
  osEaton,
  osEricsson,
  osExtreme,
  osF5,
  osFedora,
  osFireeye,
  osFortinet,
  osFreeBSD,
  osGentoo,
  osHP,
  osHPE,
  osHuawei,
  osIBM,
  osInfoblox,
  osKyocera,
  osLinux,
  osLinuxColored,
  osLinuxManjaro,
  osMacOSX,
  osMikroTik,
  osNEC,
  osNetApp,
  osNETGEAR,
  osNokia,
  osOpengear,
  osOracle,
  osOracleColored,
  osPaloAlto,
  osPeplink,
  osPfSense,
  osPress,
  osProxmox,
  osRaritan,
  osRaspbian,
  osRedHat,
  osRuckus,
  osSuseLinux,
  osSynology,
  osTPLink,
  osTrippLite,
  osUbiquiti,
  osUbuntu,
  osUbuntuColored,
  osVertiv,
  osVMware,
  osWatchGuard,
  osZebra,
  osZyxel,
  padlock,
  panTool,
  pauseOutline,
  pauseSolid,
  pencilOutline,
  pencilSolid,
  performanceOptimization,
  pie_chart_skeleton,
  pin_element,
  playOutline,
  playSolid,
  plus_mini_s,
  plus,
  pod,
  pricing,
  print,
  privacy,
  pushNotifications,
  qrCode,
  qualityOfServiceSolid,
  question,
  questionFilled,
  ram,
  rearrange,
  reduceSize,
  refresh,
  reload,
  removeNode,
  resize_handler,
  rocket,
  rotate_ccw,
  rotate_cw,
  room_home,
  room_new,
  room_overview,
  room,
  sad,
  save,
  save2,
  scheduled,
  search_s,
  search,
  searchPress,
  serviceAlarm,
  serviceApache,
  serviceApacheTomcat,
  serviceAsterisk,
  serviceBeanstalk,
  serviceBind,
  serviceContainer,
  serviceCoreDns,
  serviceCouchDB,
  serviceDatabase,
  serviceDNS,
  serviceDNSmasq,
  serviceDockerHub,
  serviceDockerHubPress,
  serviceDotNet,
  serviceEBPF,
  serviceElasticSearch,
  serviceExample,
  serviceFreeNAS,
  serviceHAProxy,
  serviceHTTPCheck,
  serviceIceCast,
  serviceInfluxDB,
  serviceIPFS,
  serviceIPVS,
  serviceKubernetes,
  serviceLighthttpd,
  serviceLighthttpd2,
  serviceLiteSpeed,
  serviceLxc,
  serviceMariaDB,
  serviceMemCached,
  serviceMongoDB,
  serviceMySQL,
  serviceMySQLPress,
  serviceNginx,
  serviceNginxLocal,
  serviceNginxPlus,
  serviceNtpd,
  serviceNtpdPress,
  serviceNvidia,
  serviceOpenStack,
  serviceOpenTelemetry,
  serviceOpenWrt,
  servicePan,
  servicePandas,
  servicePercona,
  servicePfSense,
  servicePhpFpm,
  servicePostgreSQL,
  servicePrometheus,
  serviceProxySQL,
  serviceRabbitMQ,
  serviceRandom,
  serviceRedis,
  serviceRethinkDB,
  serviceRetroShare,
  services,
  serviceSelectedArea,
  serviceSendgrid,
  serviceSolr,
  serviceSquid,
  servicesSmartdlog,
  serviceSummaryStatistic,
  serviceSystemd,
  serviceTraefik,
  serviceVarnish,
  serviceWebLog,
  serviceWebLogNginx,
  serviceX509Check,
  serviceXen,
  settings_h,
  settings,
  share,
  socialChat,
  sign_in,
  sort_ascending,
  sort_descending,
  sort_indicator,
  sorting_asc,
  sorting_desc,
  sorting_vertical,
  space_new,
  space,
  spaces_v2,
  stockConfig,
  switch_off,
  system_overview,
  systemOverviewPress,
  text_add,
  thumb_down,
  thumb_up,
  thunder,
  tiny_buttons,
  tools,
  top,
  training,
  trashcan,
  triangle_down,
  triangle,
  universe,
  unknownError,
  unreachable,
  unreachableNode,
  update_pending,
  update,
  upload,
  user,
  userConfig,
  userPress,
  users,
  value,
  view_list,
  viewSingleNode,
  viewSingleNodePress,
  virtualization,
  warning_triangle_hollow,
  warning_triangle,
  warning,
  weights_compare,
  weights_drill_down,
  windows,
  x,
  zoomIn,
  zoomOut,
  zoomReset,

  N,
  I,
  D,
  L,
}
